import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom'
import App from '../App.tsx'
// import ApplicantsPage from '../app/pages/applicants/Page.tsx'
import AcademicTermsPage from '@/app/pages/academic_terms/create_academic_term/Page.tsx'
import ViewAcademicTermsPage from '@/app/pages/academic_terms/view_academic_terms/Page.tsx'
import PaymentApprovalRulesPage from '@/app/pages/payment-approval-rules/page.tsx'
import ProgramPurseSettings from '@/app/pages/program_purse_settings/Page.tsx'
import DistributionHistoryPage from '@/app/pages/program_purse_settings/purse-details/_components/distribution-history/distribution-history-page.tsx'
import PurseDetailView from '@/app/pages/program_purse_settings/purse-details/purse-detail-page.tsx'
import AddProductPage from '@/app/pages/providers/components/AddProduct/AddProductPage.tsx'
import ConfigureStorePage from '@/app/pages/providers/components/configureStore/StoreConfigPage.tsx'
import DocumentsTabPage from '@/app/pages/providers/components/Documents'
import ProvidersHistoryView from '@/app/pages/providers/components/HistoryView'
import SchoolFormPage from '@/app/pages/providers/components/SchoolFormPage/SchoolFormPage.tsx'
import ProvidersPage from '@/app/pages/providers/Page.tsx'
import ManageUsersPage from '@/app/pages/providers/provider-user-management/Page.tsx'
import SystemCatalogPage from '@/app/pages/setup/system_catalog/SystemCatalogPage.tsx'
import { NotificationProvider } from '@/common/components/Notifications/NotificationProvider.tsx'
import { LayoutProvider } from '@/layouts/LayoutProvider.tsx'
import { ApplicationProvider } from '@/pages/applicants/applicant_details/ApplicantContext.tsx'
import ApplicantDetailsWrapper from '@/pages/applicants/applicant_details/ApplicantDetailsWrapper.tsx'
import ApplicantDocuWrapper from '@/pages/applicants/applicant_details/ApplicantDocumentsWrapper.tsx'
import ApplicantHistoryWrapper from '@/pages/applicants/applicant_details/ApplicantHistoryWrapper.tsx'
import ApplicantsDetailsPage from '@/pages/applicants/applicant_details/Page.tsx'
import PreSelectedView from '@/pages/applicants/pre_selected/PreSelectedView.tsx'
import CheckEmailPage from '@/pages/authentication/forgot_password/check_email/Page.tsx'
import EnterEmailPage from '@/pages/authentication/forgot_password/enter_email/Page.tsx'
import InactivityLogout from '@/pages/authentication/InactivityLogout.ts'
import { KeyCloakAuthGuarded } from '@/pages/authentication/KeyCloakAuthGuarded.tsx'
import LoginPage from '@/pages/authentication/login/Page.tsx'
import { TwoFAuth } from '@/pages/authentication/login/TwoFAuth.tsx'
import ResetPasswordPage from '@/pages/authentication/reset_password/Page.tsx'
import SignUpPage from '@/pages/authentication/sign_up/Page.tsx'
import { ChatPage } from '@/pages/Chat/Page.tsx'
import DashboardPage from '@/pages/dashboard/Page.tsx'
import NotAccessPage from '@/pages/not_access/NotAccessPage.tsx'
import PaymentsPage from '@/pages/payments/Page'
import PaymentDetailsPage from '@/pages/payments/PaymentDetails'
import UsersProfileView from '@/pages/profile/UsersProfileView.tsx'
import { DistributionSettingsTabLoader } from '@/pages/program_purse_settings/purse-details/_components/distribution-settings-options/purse-detail-view/distribution-settings-tab-loader.tsx'
import { FinancialTabLoader } from '@/pages/program_purse_settings/purse-details/_components/distribution-settings-options/purse-detail-view/financial-data-loader.tsx'
import { TransactionsTabLoader } from '@/pages/program_purse_settings/purse-details/_components/distribution-settings-options/purse-detail-view/transactions-tab-loader.tsx'
import ProgramsPage from '@/pages/programs/Page.tsx'
import MarketplaceTabPage from '@/pages/providers/components/Marketplace/Marketplace.tsx'
import ProviderInfoTabPage from '@/pages/providers/components/ProviderInfo'
import TransactionsTabPage from '@/pages/providers/components/Transactions'
import ProviderDetailsPage from '@/pages/providers/ProviderDetails'
import AccessView from '@/pages/setup/accesses/AccessView.tsx'
import GlobalItemsPage from '@/pages/setup/global_items/Page.tsx'
import LinkHandlersPage from '@/pages/setup/link_handlers/Page.tsx'
import SetupPage from '@/pages/setup/Page.tsx'
import ProgramView from '@/pages/setup/program/ProgramView.tsx'
import ProviderCategoriesPage from '@/pages/setup/provider_categories/ProviderCategoriesPage.tsx'
import UsersDetailView from '@/pages/setup/users/UsersDetailView.tsx'
import UsersHistoryView from '@/pages/setup/users/UsersHistoryView.tsx'
import UsersView from '@/pages/setup/users/UsersView.tsx'
import NextUpQueue from '@/pages/tasks/NextUpQueue/NextUpQueue.tsx'
import NextUpQueuePage from '@/pages/tasks/NextUpQueue/page.tsx'
import TaskPage from '@/pages/tasks/Page.tsx'
import TransactionsPage from '@/pages/transactions/Page'
import TransactionDetailsPage from '@/pages/transactions/TransactionDetails'
import AuthSessionMonitor from '../app/services/AuthSessionMonitor.tsx'
import { AppRoutePaths } from './route_paths.ts'
import ProviderAffiliationsPage from '@/pages/setup/provider_affiliations/ProviderAffiliationsPage.tsx'
import AffiliationManageProvidersPage from '@/pages/setup/provider_affiliations/manage_providers/Page.tsx'
import ApplicantPaymentsWrapper from '@/pages/applicants/applicant_details/ApplicantPaymentsWrapper.tsx'

const AUTH_ROUTES: RouteObject[] = [
  {
    path: '/',
    element: <KeyCloakAuthGuarded />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
        index: true,
      },
      {
        path: 'twofa',
        element: <TwoFAuth />,
        index: true,
      },
      {
        path: '/',
        children: [
          {
            path: '/forgot_password',
            children: [
              {
                path: '',
                element: <EnterEmailPage />,
              },
              {
                path: 'enter_email',
                element: <EnterEmailPage />,
              },
              {
                path: 'check_email',
                element: <CheckEmailPage />,
              },
            ],
          },
        ],
      },
      {
        path: '/reset_password',
        element: <ResetPasswordPage />,
      },
    ],
  },
]

const PUBLIC_ROUTES: RouteObject[] = [
  {
    path: '/',
    element: <DashboardPage />,
    handle: {
      page_details: {
        title: 'Dashboard',
        description: 'A statistical snap shot of your program',
      },
    },
  },
  {
    path: '/sign_up',
    element: <SignUpPage />,
  },
]

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthSessionMonitor>
        <InactivityLogout>
          <LayoutProvider>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </LayoutProvider>
        </InactivityLogout>
      </AuthSessionMonitor>
    ),
    children: [
      {
        path: AppRoutePaths.dashboard.index,
        element: <DashboardPage />,
        handle: {
          page_details: {
            title: 'Dashboard',
            description: 'A statistical snap shot of your program',
          },
        },
      },
      {
        path: AppRoutePaths.applicants.pre_selected.index,
        element: <PreSelectedView />,
        handle: {
          page_details: {
            title: 'Applicants',
            description:
              'View program applicants, manage their notifications and configure the lottery.',
          },
        },
      },
      {
        path: AppRoutePaths.payments.index,
        element: <PaymentsPage />,
        handle: {
          page_details: {
            title: 'Financial Task',
            description: 'View pending payments, manage their statuses.',
          },
        },
      },
      {
        path: AppRoutePaths.payments.details.index,
        element: <PaymentDetailsPage />,
      },
      {
        path: AppRoutePaths.transactions.index,
        element: <TransactionsPage />,
        handle: {
          page_details: {
            title: 'Transactions',
            description: 'View transactions, payments already completed.',
          },
        },
      },
      {
        path: AppRoutePaths.transactions.details.index,
        element: <TransactionDetailsPage />,
      },
      {
        path: AppRoutePaths.tasks.index,
        element: <TaskPage />,
        handle: {
          page_details: {
            title: '',
            description: '',
          },
        },
      },

      {
        path: AppRoutePaths.tasks.queue,
        element: <NextUpQueuePage />,
        handle: {
          page_details: {
            title: '',
            description: '',
          },
        },
        children: [
          {
            path: '/tasks/next_up_queue',
            element: <NextUpQueue />,
          },
          {
            path: '/tasks/next_up_queue/:applicantId/documents',
            element: <ApplicantDocuWrapper />,
          },
        ],
      },

      {
        path: AppRoutePaths.not_access.index,
        element: <NotAccessPage />,
        handle: {
          page_details: {
            title: '',
            description: '',
          },
        },
      },
      {
        path: AppRoutePaths.academic_terms.create,
        element: <AcademicTermsPage />,
      },
      {
        path: AppRoutePaths.academic_terms.view,
        element: <ViewAcademicTermsPage />,
      },

      {
        path: '/applicants/:applicantId',
        element: (
          <ApplicationProvider>
            <ApplicantsDetailsPage />
          </ApplicationProvider>
        ),
        handle: {
          page_details: {
            title: '',
            description: '',
          },
        },
        children: [
          {
            index: true,
            path: 'details',
            element: <ApplicantDetailsWrapper />,
          },
          {
            path: 'history',
            element: <ApplicantHistoryWrapper />,
          },
          {
            path: 'documents',
            element: <ApplicantDocuWrapper />,
          },
          {
            path: 'chat',
            element: <ChatPage />,
          },
          {
            path: 'payments',
            element: <ApplicantPaymentsWrapper />,
          },
        ],
      },

      {
        path: '/providers/:providerId',
        element: <ProviderDetailsPage />,

        handle: {
          page_details: {
            title: 'Provider',
            description: `Take control of the site's setting.`,
          },
        },
        children: [
          {
            index: true,
            path: AppRoutePaths.providers.provider_details.provider_info,
            element: <ProviderInfoTabPage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.transactions,
            element: <TransactionsTabPage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.manage_users,
            element: <ManageUsersPage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.marketplace,
            element: <MarketplaceTabPage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.add_product,
            element: <AddProductPage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.school_form,
            element: <SchoolFormPage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.store_config,
            element: <ConfigureStorePage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.documents,
            element: <DocumentsTabPage />,
          },
          {
            path: AppRoutePaths.providers.provider_details.history,
            element: <ProvidersHistoryView />,
          },
        ],
      },
      {
        path: AppRoutePaths.setup.index,
        element: <SetupPage />,
        handle: {
          page_details: {
            title: 'Setup',
            description: `Take control of the site's setting.`,
          },
        },
        children: [
          {
            path: AppRoutePaths.setup.program.index,
            element: <ProgramView />,
          },
          {
            path: AppRoutePaths.setup.users.index,
            element: <UsersView />,
          },
          {
            path: AppRoutePaths.setup.roles.index,
            element: <AccessView />,
          },
          {
            path: AppRoutePaths.setup.systemCatalog.index,
            element: <SystemCatalogPage />,
          },
          {
            path: AppRoutePaths.setup.global_items.index,
            element: <GlobalItemsPage />,
          },
          {
            path: AppRoutePaths.setup.provider_categories.index,
            element: <ProviderCategoriesPage />,
          },
          {
            path: AppRoutePaths.setup.help_links.index,
            element: <LinkHandlersPage />,
          },
          {
            path: AppRoutePaths.setup.category_and_product_rules.index,
            element: <PaymentApprovalRulesPage />,
          },
          {
            path: AppRoutePaths.setup.provider_affiliations.index,
            element: <ProviderAffiliationsPage />,
          },
        ],
      },
      {
        path: AppRoutePaths.providers.index,
        element: <ProvidersPage />,
        handle: {
          page_details: {
            title: 'Providers',
            description: 'A list of medical providers under this program.',
          },
        },
      },
      {
        path: AppRoutePaths.programs.index,
        element: <ProgramsPage />,
        handle: {
          page_details: {
            title: 'Program List',
            description: '',
          },
        },
      },
      {
        path: AppRoutePaths.purse_settings.index,
        element: <ProgramPurseSettings />,
      },
      {
        path: AppRoutePaths.purse_settings.id,
        element: <PurseDetailView />,
        children: [
          { index: true, element: <Navigate to="overview" replace /> },
          { path: 'overview', element: <FinancialTabLoader /> },
          { path: 'distribution', element: <DistributionSettingsTabLoader /> },
          {
            path: 'distribution-history',
            element: <DistributionHistoryPage />,
          },
          { path: 'transactions', element: <TransactionsTabLoader /> },
        ],
      },
      {
        path: AppRoutePaths.my_profile.index,
        element: <UsersProfileView />,
        handle: {
          page_details: {
            title: 'Edit Profile',
            description: '',
          },
        },
      },
      {
        path: 'setup/users/:userId',
        handle: {
          page_details: {
            title: '',
            description: '',
          },
        },
        children: [
          {
            index: true,
            path: 'details',
            element: <UsersDetailView />,
          },
          {
            path: 'history',
            element: <UsersHistoryView />,
          },
        ],
      },
      {
        path: AppRoutePaths.setup.provider_affiliations.manage_providers,
        handle: {
          page_details: {
            title: '',
            description: '',
          },
        },
        element: <AffiliationManageProvidersPage />,
      },
    ],
  },
  ...AUTH_ROUTES,
  ...PUBLIC_ROUTES,
])
